import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'src/lib/lib-ngx/web-services/auth.service';
import { GAdsService } from '../services/gads.service';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const gAdsService = inject(GAdsService);
  const router = inject(Router);

  if (authService.isLoggedIn()) {
    gAdsService.reset();
    return true;
  }

  router.navigate(['/onboarding/welcome'], { replaceUrl: true });

  return false;
};
